module.exports = __webpack_public_path__ + "img/accessory_shoe_06.bb24dce0.svg";